import { useStyles } from "@/pages/campaign-form/components/layouts/SingleColumnLayout/SingleColumnLayout.styles"
import { useMediaQuery } from "@mantine/hooks"
import React from "react"
interface Props {
    children?
    width?: number
    rightColumn?: boolean
}

export const SingleColumnLayout = ({ children = [], width, rightColumn }: Props) => {
    const isSmallerThanWidth = useMediaQuery(`(max-width: ${(width ?? 1000) + 120}px)`)
    const { classes } = useStyles({ width: width ? (isSmallerThanWidth ? "100%" : `${width}px`) : "100%" })
    const childrenArray = React.useMemo(() => (Array.isArray(children) ? children : [children]), [children])
    return (
        <div className={rightColumn ? classes.rightContent : classes.content} id="layout-default">
            {childrenArray}
        </div>
    )
}
